import { create } from 'zustand';

// ==================== TYPES ====================

export type EditingType = 'create' | 'edit';
export type ResumeContentType = 'masterTemplate' | 'skills' | 'experience' | 'fullResume' | 'education' | 'notes';

export interface ResumeEditorState {
  // Editor state
  activeContentId?: string;
  editingType?: EditingType;

  // Selection state for compilation
  selectedMasterTemplateId?: string;
  selectedContentIds: string[];

  // Filter state
  contentTypeFilter?: ResumeContentType;

  // Methods
  setActiveContent: (id?: string) => void;
  clearActiveContent: () => void;
  setEditingType: (type?: EditingType) => void;
  setSelectedMasterTemplate: (id?: string) => void;
  toggleContentSelection: (id: string) => void;
  addContentSelection: (id: string) => void;
  removeContentSelection: (id: string) => void;
  clearSelection: () => void;
  setContentTypeFilter: (type?: ResumeContentType) => void;
}

// ==================== STORE ====================

export const useResumeStore = create<ResumeEditorState>((set) => ({
  // Initial state
  activeContentId: undefined,
  editingType: undefined,
  selectedMasterTemplateId: undefined,
  selectedContentIds: [],
  contentTypeFilter: undefined,

  // Methods
  setActiveContent: (id?: string) => set({ activeContentId: id }),
  clearActiveContent: () => set({ activeContentId: undefined }),

  setEditingType: (type?: EditingType) => set({ editingType: type }),

  setSelectedMasterTemplate: (id?: string) => set({ selectedMasterTemplateId: id }),

  toggleContentSelection: (id: string) =>
    set((state) => ({
      selectedContentIds: state.selectedContentIds.includes(id)
        ? state.selectedContentIds.filter((contentId) => contentId !== id)
        : [...state.selectedContentIds, id],
    })),

  addContentSelection: (id: string) =>
    set((state) => ({
      selectedContentIds: state.selectedContentIds.includes(id)
        ? state.selectedContentIds
        : [...state.selectedContentIds, id],
    })),

  removeContentSelection: (id: string) =>
    set((state) => ({
      selectedContentIds: state.selectedContentIds.filter((contentId) => contentId !== id),
    })),

  clearSelection: () =>
    set({
      selectedMasterTemplateId: undefined,
      selectedContentIds: [],
    }),

  setContentTypeFilter: (type?: ResumeContentType) => set({ contentTypeFilter: type }),
}));
